import api from "@/libs/axios";
import { useMutation } from "@tanstack/react-query";
import { apiEnum } from "@shared/types/enums/apiEnum";
import { MutationConfig } from "@/libs/query";
import {
  DateTimeFormatEntity,
  DefaultLocationEntity,
  OrganizerSettingEntity,
  QuickButtonEntity,
  TileConfigurationEntity,
} from "./entities/organizerSettingEntity";

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
type PayLoadType = {
  organizerEmail: string;
  hasAssistant?: boolean;
  assistantType?: number;
  assistantEmail?: string;
  assistantName?: string;
  defaultLocations?: DefaultLocationEntity;
  defaultResourceType?: string;
  defaultCategoryIds?: string;
  quickButtons?: QuickButtonEntity[];
  showCategoryIcon?: boolean;
  recommendationScreen?: boolean;
  capacityFilter?: boolean;
  aiAssistant?: boolean;
  lastUpdated?: string;
  tileConfiguration?: TileConfigurationEntity;
  dateTimeFormat?: DateTimeFormatEntity;
};

const createOrganizerSetting = async (payload: PayLoadType) => {
  const { data } = await api.post(apiEnum.organizerSetting, payload);
  return new OrganizerSettingEntity(data.data);
};

type CreateOrganizerSettingType = {
  mutationConfig?: MutationConfig<(payload: PayLoadType) => Promise<OrganizerSettingEntity>>;
};

export const useCreateOrganizerSetting = ({ mutationConfig }: CreateOrganizerSettingType) => {
  return useMutation({
    ...mutationConfig,
    mutationFn: createOrganizerSetting,
  });
};
